import { ReactNode } from 'react'
import Image, { StaticImageData } from 'next/image'
import AE from '@public/image/cc/AE.png'
import CUP from '@public/image/cc/CUP.png'
import DI from '@public/image/cc/DI.png'
import DN from '@public/image/cc/DN.png'
import JCB from '@public/image/cc/JCB.png'
import MC from '@public/image/cc/MC.png'
import MI from '@public/image/cc/MI.png'
import NONE from '@public/image/cc/NONE.png'
import PP from '@public/image/cc/PP.png'
import VI from '@public/image/cc/VI.png'

import {
  AffirmItemIcon,
  ApplePayIcon,
  GooglePayItemIcon,
  PaypalItemIcon,
  VenmoItemIcon,
} from '@/components/icons'

export const paymentMethodLogoMap: Record<string, JSX.Element> = {
  braintree_paypal: <PaypalItemIcon />,
  braintree_googlepay: <GooglePayItemIcon />,
}

/**
 * 支付卡片图标
 */
export const PAYMENT_METHODS_CARD_IMAGES = {
  AE: AE,
  CUP: CUP,
  DI: DI,
  DN: DN,
  JCB: JCB,
  MC: MC,
  MI: MI,
  PP: PP,
  VI: VI,
  NONE: NONE,
}

const ImageComponent = ({
  src,
  alt,
  width = 40,
  height = 25,
}: {
  src: StaticImageData
  alt: string
  width?: number
  height?: number
}) => (
  <div style={{ position: 'relative', width, height }}>
    <Image src={src} fill style={{ objectFit: 'contain' }} alt={alt} />
  </div>
)

export const ORDER_DETAIL_PAYMENT_METHOD_LOGO: {
  [key: string]: ReactNode | StaticImageData | unknown
} = {
  // braintree: <ImageComponent src={NONE} alt="braintree" />,
  braintree_applepay: <ApplePayIcon />,
  braintree_googlepay: <GooglePayItemIcon />,
  braintree_paypal: <PaypalItemIcon />,
  braintree_venmo: <VenmoItemIcon />,
  braintree_paypal_vault: (
    <ImageComponent src={PAYMENT_METHODS_CARD_IMAGES.PP} alt="braintree_paypal_vault" />
  ),
  // braintree_cc_vault: <Image
  //   fill
  //   src={
  //     PAYMENT_METHODS_CARD_IMAGES[
  //     item.cardType as keyof typeof PAYMENT_METHODS_CARD_IMAGES
  //     ]
  //   }
  //   objectFit="contain"
  //   alt="braintree_cc_vault"
  // />,
  affirm_gateway: <AffirmItemIcon />,
}
